import React from 'react';
import { Button, Spacer, ContentBoxContainer, ContentBoxText, ContentBoxFigure, PenlySeo } from 'components';
import { mediaQueries, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';

export default function ForCompanies() {
    const title = 'Effektiviser din rådgivning med adgang til værdifuld kundedata';
    const description = 'Med Penlys værktøjer kan du få adgang til de data der er vigtige for din rådgivning. Lad kunden nemt og sikkert dele sine data med dig. Se mere her.';
    const image = { url: '/static/gfx/content/penly-content-12.jpg' };
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    <h1 className="nomb">Tag din <span className="color-highlight">onboarding</span> til et nyt niveau</h1>
                    <p className="large">
                        Penly giver forbrugere indsigt i deres privatøkonomi ved hjælp af vores digitale værktøjer.
                        Som rådgiver kan du anmode en Penly-bruger om adgang til at dele deres Penly-profil med dig.
                    </p>
                </ContentBoxText>
                <ContentBoxFigure className="penlylogoSymbol"></ContentBoxFigure>
            </ContentBoxContainer>

            <ContentBoxContainer>
                <ContentBoxFigure figure="/static/gfx/content/penly-content-12.jpg" className="brbr"></ContentBoxFigure>
                <ContentBoxText>
                    <h3>Få adgang til din kundes data med Penly Access</h3>
                    <p>
                        Penly Access giver dig mulighed for at integrere data fra Penly direkte ind i jeres systemer,
                        hvis en Penly-bruger accepterer, at dele sine data med dig. Med adgang til data fra Penly kan du effektivisere og
                        optimere dine arbejdsgange og dermed give dine kunder en hurtigere og mere tilfredsstillende kundeservice.
                    </p>
                    <p>
                        Vil du høre mere om mulighederne for integration, så kontakt Kourosh Rasmussen på <a href="mailto:kourosh@penly.dk">kourosh@penly.dk</a>
                        eller på <a href="tel:+4540866164">+45 40 86 61 64</a>. Du kan ringe til os tirsdag og torsdag mellem 10.00 og 14.00.
                    </p>
                </ContentBoxText>
            </ContentBoxContainer>

            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <ContentBoxContainer className="mobileflip">
                <ContentBoxText>
                    <h3>Mangler du et værktøj til håndtering af data?</h3>
                    <p>
                        Er du finansiel rådgiver og mangler du et system til håndtering af dine kunders data?
                        Som finansiel rådgiver, kan du via Teal Business få adgang til din kundes data på platformen Monax,
                        som er vores tæt integrerede samarbejdspartner der tilbyder finansielle B2B services.
                    </p>
                    <p>
                        Monax’s rådgivningsplatform giver dig adgang til effektive analyseværktøjer og sikker datahåndtering.
                    </p>
                    <p>
                        Vil du høre mere om Monax, så kontakt Kourosh Rasmussen på <a href="mailto:kourosh@penly.dk">kourosh@penly.dk</a>
                    </p>
                    { /*
                    <div className="center">
                        <Button color="monax" onClick={ () => window.open('https://www.Monax.dk') }>
                            Læs mere om Monax
                        </Button>
                    </div>
                    */ }
                </ContentBoxText>
                <ContentBoxFigure className="brbr brtl background-monaxprimary monaxLogoWhite"></ContentBoxFigure>
            </ContentBoxContainer>

            { fromTablethori ? <Spacer size="huge" /> : <Spacer /> }

            <ContentBoxContainer>
                <ContentBoxFigure className="brbr brtl centered">
                    <img src="/static/gfx/MonaxLogoSymbol.svg" />
                </ContentBoxFigure>
                <ContentBoxText>
                    <h3>Sådan foregår deling af data fra din kunde</h3>
                    <p>
                        Deling af data foregår ved, at en rådgiver sender en anmodning til brugeren, om denne vil dele udvalgte elementer af deres Penly-profil f.eks.
                        Pensionsinfo-rapporten fra de seneste 3 år inkl. Penly PensionsTjeks-analyser heraf.
                    </p>
                    <ul>
                        <li>
                            Hvis brugeren accepterer at dele disse data, sender vi dataen og analyserne, på brugerens vegne.
                        </li>
                        <li>
                            Hvis brugeren mangler at indhente noget data, som du har brug for, så hjælper vi brugeren med at indsamle dem.
                        </li>
                        <li>
                            Hvis brugeren ikke har en Penly-profil allerede vil brugeren blive inviteret, på vegne af dig til at starte et onboarding flow,
                            med henblik på indsamling af de data du har behov for.
                        </li>
                    </ul>
                </ContentBoxText>
            </ContentBoxContainer>

            <Spacer />
        </>
    );
}
